import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import notify from '../../../../shared/feedback/notifications';
import * as userActions from '../../../../actions/userActions';
import { Translate } from '../../../../shared/LanguageService';

class LogoutLink extends React.Component<any, any> {
    onLogout = () => {
        this.props.actions.logout();
        notify.success(Translate('system/toastr/logged-out'));
    };

    render() {
        return (
            <a
                href="#"
                className="logout"
                onClick={this.onLogout}
                title={Translate('header/nav/logout')}
            >
                <i className="material-icons">exit_to_app</i> {` ${this.props.logoutText}`}
            </a>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            logout: () => {
                dispatch(userActions.logout());
            }
        }
    };
}

export default connect(null, mapDispatchToProps)(withRouter(LogoutLink));
